// Copyright (c) 2015, NSQUARE Technologies Pvt. Ltd. and Contributors
// License: GNU General Public License v3. See license.txt

if(!window.squareerp) window.squareerp = {};

// Add / update a new Lead / Communication
// subject, sender, description
froggy.send_message = function(opts, btn) {
	return froggy.call({
		type: "POST",
		method: "squareerp.templates.utils.send_message",
		btn: btn,
		args: opts,
		callback: opts.callback
	});
};

squareerp.subscribe_to_newsletter = function(opts, btn) {
	return froggy.call({
		type: "POST",
		method: "froggy.email.doctype.newsletter.newsletter.subscribe",
		btn: btn,
		args: {"email": opts.email},
		callback: opts.callback
	});
}

// for backward compatibility
squareerp.send_message = froggy.send_message;
